import React from 'react';

import BasePage from '../BasePage';
import Navigation from '../../../components/Site/Navigation';
import ShopFooter from '../../../components/Site/Shop/ShopFooter';

class ShopTOS extends BasePage {
	render() {
		return (
			<div className="section section--operations section--operations--faq">
				<Navigation />

				<div className="section__intro">
					<h2>Frequently Asked Questions</h2>
				</div>

				<div className="section__contents">

					<h3>What are pets?</h3>
					<p>
						Tabby Cat made some friends! Now you can purchase other animals to keep alongside the original Tabby Cat. Every pet you buy is yours to keep, dress up, pet, and love forever. When you have more than one pet, you can shuffle them so that each new tab is a surprise. Just like the original Tabby Cats, each pet has lots of different names, colors, and behaviors. Some even unlock new goodies...!
					</p>

					<h3>Will Tabby Cat always be free?</h3>
					<p>
						Yes! The original Tabby Cat will be free forever and you will continue to receive new goodies over time.
					</p>

					<h3>How do payments work?</h3>
					<p>
						Payments are handled through Google Wallet and managed through Google’s In-App Payments platform, so your data is secure. Tabby Cat only sees what you’ve purchased. When you’re logged into Google Chrome your pets will sync across all of your computers. If you’re not sure how to log into Google Chrome, follow <a className="external-link" href="https://support.google.com/chrome/answer/185277?co=GENIE.Platform%3DDesktop&hl=en" target="_blank" rel="noopener noreferrer">these instructions on Google’s Help Center</a>.
					</p>

					<h3>Where does my money go?</h3>
					<p>
						Every purchase you make goes towards the creation of more pets and goodies. New pets will be released regularly, and if you have ideas for pets you’d like to see you can send them to <a className="external-link" href="mailto:meow@tabbycats.club">meow@tabbycats.club</a>!
					</p>
				</div>

				<ShopFooter />
			</div>
		);
	}
}

export default ShopTOS;



// WEBPACK FOOTER //
// ./src/routes/Site/Operations/FAQ.js